module.exports = __webpack_public_path__ + "img/one.80ab4791.png";